export const getValues = (value: any[] | string): Set<string> =>
  new Set<string>(typeof value === "string" ? value.split(",").filter((x) => !!x) : value);
